import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { getPartners, getSiteContent } from '../api/api';

export const Partenaires = () => {
  const [partners, setPartners] = useState([]);
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [partnersData, contentData] = await Promise.all([
          getPartners(),
          getSiteContent()
        ]);
        setPartners(partnersData);
        setContent(contentData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <div className="min-h-screen bg-white flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF1B6D]"></div></div>;
  }

  return (
    <div className="min-h-screen bg-white">
      <section className="py-20 lg:py-32 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-[#FF1B6D] mb-6">{content?.partnersTitle || 'Nos Partenaires'}</h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">{content?.partnersSubtitle || 'Merci à nos partenaires qui soutiennent la culture urbaine'}</p>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-32">
        <div className="container mx-auto px-4 lg:px-8">
          {partners.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
              {partners.map((partner, i) => (
              <div key={i} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all hover:-translate-y-2">
                {partner.logo ? (
                  <div className="w-20 h-20 mb-4 mx-auto flex items-center justify-center">
                    <img src={partner.logo} alt={partner.name} className="max-w-full max-h-full object-contain" />
                  </div>
                ) : (
                  <div className="w-16 h-16 bg-[#FF1B6D] rounded-full flex items-center justify-center mb-4 mx-auto">
                    <span className="text-white font-black text-2xl">{partner.name.charAt(0)}</span>
                  </div>
                )}
                <h3 className="font-bold text-gray-900 text-center mb-2">{partner.name}</h3>
                <p className="text-gray-600 text-sm text-center">{partner.description}</p>
              </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-600 py-12">Aucun partenaire pour le moment</p>
          )}

          <div className="text-center">
            <Link to="/contact">
              <Button className="bg-[#FF1B6D] hover:bg-[#E01660] text-white font-bold text-lg px-10 py-7 rounded-full">
                Contactez-nous <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};